import enums from '~/server_shared/enums.json';
import type { UpdateExposureLineItemsRequestCoverageDecisionOption } from '~/server_shared/openapi/data-contracts';

export const DEPRECIATION_CATEGORIES = Object.entries(enums.DEPRECIATION_CATEGORIES).map(([value, label]) => ({
  value,
  label,
}));

export type DepreciationCategory = keyof typeof enums.DEPRECIATION_CATEGORIES;

export interface LineItemProps {
  id?: string;
  description?: string;
  amount?: number;
  covered_amount?: number;
  coverage_decision?: UpdateExposureLineItemsRequestCoverageDecisionOption;
  coverage?: string;
  exposure_id?: number;
  explanation?: string;
  document_id?: number;
  invoice_id?: number;
  amount_currency?: string;
  item_date?: string;
  invoice_date?: string;
  conversion_date?: string;
  conversion_rate?: number;
  base_amount?: number;
  // Depreciation fields
  category?: string;
  months_owned?: number;
  is_depreciation_overridden?: boolean;
  // Payable type field
  payable_type?: 'expenses' | 'indemnity';
  // Payment request fields
  payment_request_id?: number | null;
  payment_financial_status?: string | null;

  is_locked?: boolean;
  third_party_amount?: number;
  entry_type?: string;
}

export interface ValueDescription {
  description: string;
  value: string;
  damage_assessment_include_depreciation?: boolean;
}

export interface InvoiceData {
  date?: string;
  number?: string;
  vendor?: string;
  total_amount?: number;
  document_claim_internal_id?: number;
}

export type StatusType = 'initial' | 'success' | 'error' | 'warning' | 'info';

export interface InvoiceAnalysisResponse {
  line_items: LineItemProps[];
  coverages: CoveredItemRow[];
  invoice_data: InvoiceData;
}

export interface LineItemRow extends LineItemProps {
  id: string;
  order: number;
}

export interface CoveredItemRow {
  id: string;
  coverage: string;
  amounts: Record<string, number>;
}
